module.exports = __webpack_public_path__ + "img/introducepinx_headerimage.802a6deb.jpg";